import { OrganizationAuthMethodEnum } from 'src/api/main'

import { EMAIL_OTP_METHOD, QR_LOGIN_METHOD, providerOrder } from './constants'
import type { ProviderCatalogItem, ProviderId, ProviderScope } from './types'

const catalogById: Record<ProviderId, ProviderCatalogItem> = {
  [OrganizationAuthMethodEnum.PASSWORD]: {
    id: OrganizationAuthMethodEnum.PASSWORD,
    i18nKey: 'authMethods.password',
    scope: 'both',
    capabilities: []
  },
  [EMAIL_OTP_METHOD]: {
    id: EMAIL_OTP_METHOD,
    i18nKey: 'authMethods.emailOtp',
    scope: 'both',
    capabilities: ['login']
  },
  [QR_LOGIN_METHOD]: {
    id: QR_LOGIN_METHOD,
    i18nKey: 'authMethods.qrLogin',
    scope: 'both',
    capabilities: ['login']
  },
  [OrganizationAuthMethodEnum.GOOGLE]: {
    id: OrganizationAuthMethodEnum.GOOGLE,
    i18nKey: 'authMethods.google',
    scope: 'both',
    capabilities: ['login', 'connect', 'orgConnect', 'unlink', 'orgUnlink']
  },
  [OrganizationAuthMethodEnum.ENTRAID]: {
    id: OrganizationAuthMethodEnum.ENTRAID,
    i18nKey: 'authMethods.entraid',
    scope: 'organization',
    capabilities: ['connect', 'orgConnect', 'unlink', 'orgUnlink']
  },
  [OrganizationAuthMethodEnum.APPLE]: {
    id: OrganizationAuthMethodEnum.APPLE,
    i18nKey: 'authMethods.apple',
    scope: 'both',
    capabilities: ['login', 'connect', 'orgConnect', 'unlink', 'orgUnlink']
  },
  [OrganizationAuthMethodEnum.PASSKEY]: {
    id: OrganizationAuthMethodEnum.PASSKEY,
    i18nKey: 'authMethods.passkey',
    scope: 'both',
    capabilities: ['login']
  }
}

export const getProviderCatalog = (): ProviderCatalogItem[] =>
  providerOrder.map((id) => catalogById[id])

export const getProviderById = (providerId: ProviderId): ProviderCatalogItem =>
  catalogById[providerId]

export const supportsCapability = (
  providerId: ProviderId,
  capability: ProviderCatalogItem['capabilities'][number]
): boolean => getProviderById(providerId).capabilities.includes(capability)

export const providersForScope = (
  scope: ProviderScope
): ProviderCatalogItem[] =>
  getProviderCatalog().filter(
    (provider) => provider.scope === scope || provider.scope === 'both'
  )
